import { AsyncPipe, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, DOCUMENT, HostListener, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { AuthService, WindowRef } from '@spartacus/core';
import { Observable } from 'rxjs';
import { ScriptService } from './custom/services/script.service';
import { TrustedShopsService } from './custom/services/trustedshops.service';
import { CustomStorefrontComponent } from './spartacus/custom/cms-structure/layout/custom-storefront/custom-storefront.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [CustomStorefrontComponent, AsyncPipe]
})
export class AppComponent implements OnInit, AfterViewInit {
  private document = inject(DOCUMENT);
  private platformId = inject(PLATFORM_ID);
  isLogged$?: Observable<boolean>;

  constructor(
    private auth: AuthService,
    private trustedShopService: TrustedShopsService,
    protected winRef: WindowRef,
    protected script?: ScriptService
  ) {}

  title = 'ohgar';

  ngOnInit() {
    this.trustedShopService.loadScript();
    this.isLogged$ = this.auth.isUserLoggedIn();
  }

  ngAfterViewInit(): void {
    this.onWindowScroll();
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (this.document.body.scrollTop >= 70 || this.document.documentElement.scrollTop >= 70) {
        this.document.getElementById('wrapper-navigation')?.classList.add('background-white');
      } else {
        this.document.getElementById('wrapper-navigation')?.classList.remove('background-white');
      }
    }
  }
}
